module.exports = __webpack_public_path__ + "img/chinesecompany194.e9662a36.png";